import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/docs/page.tsx");
